import { ImmutableAPIAccessTrapError } from '../errors';

type ActionGet = {
  type: 'get';
  prop: string | symbol;
};

type ActionCall = {
  type: 'call';
  args: any[];
};

type ActionEntry = ActionGet | ActionCall;
type ActionChain = ActionEntry[];

export class AccessTrap {
  serializer: () => void;
  currentChain: ActionChain = [];
  chainStorage: Set<ActionChain> = new Set();

  constructor() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;

    this.serializer = new Proxy(function () {}, {
      apply(_target, _thisArg, args) {
        self.currentChain.push({
          type: 'call',
          args
        });

        self.chainStorage.add(self.currentChain);
        self.currentChain = [];
      },

      get(_target, prop) {
        self.currentChain.push({
          type: 'get',
          prop
        });

        return self.serializer;
      },

      set() {
        throw new ImmutableAPIAccessTrapError();
      }
    });
  }

  deserialize(target: Record<string | symbol, any> = {}) {
    this.chainStorage.forEach((chain) => {
      let targetNode = target;

      chain.forEach((entry) => {
        if (entry.type === 'get' && entry.prop in targetNode) {
          targetNode = targetNode[entry.prop];
        }

        if (entry.type === 'call' && typeof targetNode === 'function') {
          targetNode(...entry.args);
        }
      });
    });

    this.chainStorage.clear();
  }
}
